import PageTitle from "../../../components/PageTitle/PageTitle";
import { useState, useEffect, useContext, useMemo } from "react";
import Pagination from "../../../components/Pagination/Pagination";
import { AuthContext } from "../../../contexts/AuthContext";
import "./styles.scss";

export default function MyMessages() {
  const { axiosAuth, token } = useContext(AuthContext);
  const [clientSlug, setClientSlug] = useState("");
  const [hotelFilter, setHotelFilter] = useState(""); // PARA FILTRAR POR HOTEL
  const [messages, setMessages] = useState([]);
  const [hotels, setHotels] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [totalMessages, setTotalMessages] = useState(0);

  // PAGINAÇÃO
  const [page, setPage] = useState(1);
  const limit = 20;

  // EXTRAIR CLIENT_SLUG DO JWT
  useEffect(() => {
    if (!token) return;
    const payload = JSON.parse(atob(token.split(".")[1]));
    setClientSlug(payload.client_slug);
  }, [token]);

  // CARREGA LISTA DE HOTÉIS PARA PODER FILTRAR
  useEffect(() => {
    if (!clientSlug) return;
    axiosAuth
      .get(`/hotels/${clientSlug}`)
      .then(({ data }) => setHotels(data))
      .catch(console.error);
  }, [axiosAuth, clientSlug]);

  // CARREGA MSGS
  const loadMessages = async () => {
    setLoading(true);
    setError(null);
    try {
      const params = {
        skip: (page - 1) * limit,
        limit,
        client_slug: clientSlug,
        ...(hotelFilter ? { hotel_slug: hotelFilter } : {}),
      };
      const resp = await axiosAuth.get("/chat-messages/", { params });
      setMessages(resp.data.results);
      setTotalMessages(resp.data.total);
    } catch (err) {
      setError(err.response?.data?.detail || err.message);
    } finally {
      setLoading(false);
    }
  };

  const totalPages = useMemo(
    () => Math.ceil(totalMessages / limit),
    [totalMessages]
  );

  // RECARREGA AO MUDAR clientSlug, hotelFilter ou page
  useEffect(() => {
    if (clientSlug) loadMessages();
  }, [clientSlug, hotelFilter, page]);

  const hotelNameBySlug = useMemo(() => {
    const m = {};
    hotels.forEach((h) => {
      m[h.hotel_slug] = h.name;
    });
    return m;
  }, [hotels]);

  return (
    <div className="my-messages">
      <PageTitle link="" title="Mensagens dos clientes" />
      <div className="filters">
        <div>
          <label>Filtrar por hotel:</label>
          <select
            value={hotelFilter}
            onChange={(e) => {
              setHotelFilter(e.target.value);
              setPage(1);
            }}
          >
            <option value="">Todos</option>
            {hotels.map((h) => (
              <option key={h.hotel_slug} value={h.hotel_slug}>
                {h.name}
              </option>
            ))}
          </select>
        </div>
        <div>
          <button
            onClick={() => {
              setPage(1);
              loadMessages();
            }}
            disabled={loading}
          >
            {loading ? "A carregar..." : "Atualizar"}
          </button>
        </div>
      </div>
      <div className="container">
        <table className="messages-table">
          <thead>
            <tr>
              <th>ID da Sessão</th>
              <th>Origem</th>
              <th>Mensagem</th>
              <th>Hotel</th>
              <th>Data</th>
            </tr>
          </thead>
          <tbody>
            {messages.map((m) => (
              <tr key={m.id}>
                <td>{m.session_id}</td>
                <td>{m.origin}</td>
                <td className="content-cell">{m.content}</td>
                <td>{hotelNameBySlug[m.focus_slug] || m.focus_slug}</td>
                <td>{new Date(m.timestamp).toLocaleDateString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {totalMessages > limit && (
          <Pagination
            currentPage={page}
            totalPages={totalPages}
            onPageChange={(newPage) => setPage(newPage)}
          />
        )}
      </div>
    </div>
  );
}
